import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { expenseEndpoints } from '@/lib/api/endpoints';
import { expenseKeys } from '@/lib/queryKeys';
import type { Expense, CreateExpenseDto } from '@/types/settings';

export function useCreateExpense(jobId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<Expense, CreateExpenseDto>({
    mutationFn: (dto) =>
      apiPost<Expense, CreateExpenseDto>(
        operationsClient,
        expenseEndpoints.createForJob(jobId),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: expenseKeys.byJob(jobId) });
      void queryClient.invalidateQueries({ queryKey: expenseKeys.profitability(jobId) });
      toast.success('Expense created');
    },
  });
}
